// --------------------------------------------------------------
// Created On: 2022-05-11
// Author: Zachary Thomas
//
// Last Modified: 2026-02-19
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import IconTooltip from "../../../components/IconTooltip/IconTooltip";
import { MAX_COMPANY_NAME_LENGTH } from "../../../constants/miscellaneous";

// Form for filling out company information when creating a new account.
export default function CompanyForm(props: Props): Component {
  return (
    <div className="mb-4">
      <div className="mx-2 pb-3">
        <label className="mb-3">
          <span className="font-weight-bold">Company Name</span>
          <IconTooltip
            id="company-tooltip"
            icon="info-circle"
            message="This is the name that other users will see when being invited to your account or when transferring assets across accounts."
            color="var(--info-tooltip)"
          />
        </label>

        <input
          className="form-control mx-auto"
          type="text"
          maxLength={MAX_COMPANY_NAME_LENGTH}
          autoComplete="off"
          value={props.name}
          onChange={(e) => props.onChangeName(e.target.value)}
        />
      </div>
    </div>
  );
}

interface Props {
  name: string;
  onChangeName: (name: string) => void;
  companies: Company[];
  companyAlreadyExists: boolean;
}

interface Company {
  companyId: number;
  name: string;
  code: string;
}
